'use client'

import Link from 'next/link'
import { useEffect, useState, useMemo } from 'react'
import { clsx } from 'clsx'
import PAYMENT_DATA from '../payment.json'
import { isPaypayEnabled } from '@/lib/paypay'

interface PaymentDataType {
  title: string
  id: string
}

const excludeIds = [
  'identity-verification',
  'fraud-prevention',
  'paypay-details',
  'amazon-pay-details',
  'credit-card-payment',
  'paypay-payment',
]

// PayPay関連のセクションID
const paypayRelatedIds = ['paypay-details', 'paypay-payment']

// PayPay表示可否に応じてセクションをフィルタリング
const getSections = () => {
  const showPaypay = isPaypayEnabled()

  return PAYMENT_DATA.filter((item: PaymentDataType) => {
    // 基本的な除外リストに含まれる場合は除外
    if (excludeIds.includes(item.id)) {
      return false
    }
    // PayPay非表示の場合、PayPay関連セクションも除外
    if (!showPaypay && paypayRelatedIds.includes(item.id)) {
      return false
    }
    return true
  }).map((item: PaymentDataType) => ({
    id: item.id,
    label: item.title,
  }))
}

const Title = () => {
  const sections = useMemo(() => getSections(), [])
  const [activeSection, setActiveSection] = useState('')

  useEffect(() => {
    // 初期表示時のハッシュを設定
    const initialHash = window.location.hash.replace('#', '')
    if (initialHash) {
      setActiveSection(initialHash)
    }

    // スクロールイベントリスナー
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 150

      // 各セクションの位置を確認して、現在のスクロール位置に最も近いセクションを特定
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i].id)
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i].id)
          // URLのハッシュも更新（ブラウザ履歴には追加しない）
          window.history.replaceState(null, '', `#${sections[i].id}`)
          break
        }
      }
    }

    // 初回実行
    handleScroll()

    // スクロールイベントを登録
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div className="flex flex-col text-[12px] font-normal text-[#a8a8a8]">
      {sections.map((section, index) => {
        const isActive = section.id === activeSection

        return (
          <div className="leading-7 hover:cursor-pointer" key={index}>
            <Link
              onClick={() => setActiveSection(section.id)}
              href={`/payment/#${section.id}`}
              className={clsx(isActive && 'text-[#000000]')}
            >
              {section.label}
            </Link>
          </div>
        )
      })}
    </div>
  )
}

export default Title
